import { gql } from '@apollo/client';

export const FETCH_STOCKS = gql`
  query fetchStocks(
    $exchange: ExchangeSymbol
    $order: StockOrder
    $first: Int = 10
  ) {
    stocks(exchange: $exchange, order: $order, first: $first) {
      stockMarketStatus
      nodes {
        id
        name
        symbol
        exchangeSymbol
        bid
        ask
        last
        lastPriceDifference
        intradayHighPrice
        intradayLowPrice
        intradayPerChange
        intradayAccumulatedTurnover
        lastTradeDate
        intradayNumberOfTrades
      }
    }
  }
`;
